// Constants for different requests for current reducer
export default {
  roles: 'ROLES',
};
